module.exports = __webpack_public_path__ + "static/media/themeasure.536e27b9.png";